<template>
  <div class="main">

    <div class="item-list">
      <b>获客筛选</b>

      <span class="fr">

        <el-date-picker @change="changeData" v-model="Data" value-format="yyyy-MM-dd" size="small" type="daterange" range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker>

        <el-button :type="activeShow==index?'dialog-confirm':'dialog-cancel'" size="small" v-for="(item,index) in tabList" :key="index" @click="clickTab(item,index)">
          {{item.text}}
        </el-button>

        <!-- <span v-for="(item,index) in tabList" :key="index" :class="activeShow==index?'activeClass tabItem':'tabItem'" @click="clickTab(item,index)">{{item.text}}</span> -->
      </span>

    </div>

    <searchhead-checkbox searchType="3" :hideSome='true' @set-condition="setCondition" ref="SearchheadCheckbox" :searchTitle="'匿名获客查询'" @clickExpand="clickExpand"></searchhead-checkbox>
    <company-card-list v-loading.lock="waiting" :companyType="7" class="ccl" :batchActions="batchActions" ref="cardlist" :list="list" @handle-page-num="handlePageNum" @handle-page="handlePage">
      <div style="display: flex;align-items: center; padding-right: 24px">
        <div class="font-15-md">小T为您找到 <span class="blueColor" style="color: #5088FF;">{{_totalElements}}</span> 家企业</div>
        <div class="tips">
          *潜客说明：同一IP访问时会同时返回定位范围内的多家潜客企业
        </div>
      </div>
    </company-card-list>
    <robot />
    <anonymousDialog ref="anonymous" @siteSelectList="siteSelectList" @clickFlash="clickFlash" />
    <anonymousCustomersDialog :content="content" ref="anonymousCustomers" @newCompany="newCompany" />
    <setDrawer ref="setDrawer" />
    <right-float ref="rightFloat" :globalRfType="true"></right-float>
  </div>
</template>

<script>
import { getDay } from '@/base/global.js'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import SearchheadCheckbox from '../components/searchHeadCheckBox'
import CompanyCardList from '../components/companyCardList'
import { queryAnonymousCompany, queryAnonymousJS, siteSelectList } from '../api/newClueApi'
import Robot from '../components/robot'
import anonymousCustomersDialog from '../components/anonymousCustomersDialog'
import anonymousDialog from '../components/anonymousDialog'
import setDrawer from '../components/setDrawer'
import RightFloat from '@/components/rightFloatBtn'
export default {
  provide() {
    return {
      unlockSourceType: 7
    }
  },
  components: {
    SearchheadCheckbox,
    CompanyCardList,
    Robot,
    anonymousCustomersDialog,
    anonymousDialog,
    setDrawer,
    RightFloat
  },
  data() {
    return {
      expand: false,
      list: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        tab: 1,
        tableData: []
      },
      categoryId: '',
      areaCodeId: '',
      waiting: false,
      lastParams: {},
      Data: '',
      activeShow: 0,
      tabList: [{ date: -7, text: '近7天' }, { date: -30, text: '近30天' }, { date: -90, text: '近90天' }],
      DataParams: {},
      firstShow: false,
      secondShow: 0,
      content: ''
    }
  },
  computed: {
    ...mapState({
      surplus: state => state.user.surplus,
      selectAreaFlattenMap: state => state.asyncRoute.selectAreaFlattenMap,
    }),
    batchActions() {
      return this.surplus < 1 ? [false, true, false] : [true, true, false]
    },
    _totalElements() {
      if (this.list.total < 100) return this.list.total
      if (this.list.total < 200000) return `${this.list.total.toString().split('').reduce((res, v) => res ? res + 0 : v, '')}+`
      return '200000+'
    },
  },
  watch: {
    expand: function (val) {
      if (val) {
        // document.querySelector('.item-list').style.height = '72px'
        // document.querySelector('.item-list').style.lineHeight = '72px'
        document.querySelector('.checkBoxes').style.paddingTop = '74px'
      } else {
        // document.querySelector('.item-list').style.height = '72px'
        // document.querySelector('.item-list').style.lineHeight = '72px'
        document.querySelector('.checkBoxes').style.paddingTop = '74px'
      }
    }
  },
  beforeDestroy() {
    // this.getPageWrapPadding()
  },
  mounted() {
    // this.setPageWrapPadding()
    // this.newCompany()
    this.siteSelectList()

    if (this.$route.query.isSite) {
      this.$refs['SearchheadCheckbox'].setChooseSite(this.$route.query.siteId, this.$route.query.mainUrl)
    }

  },
  methods: {
    clickExpand(expand) {
      this.expand = expand
    },
    queryAnonymousJS(id) {
      queryAnonymousJS({ id: id }).then(res => {
        this.content = res.data.content
        if (!res.data.isSuccess || res.data.isSuccess == 0) {
          if (res.data.status == 1) {
            this.$refs.anonymousCustomers.handleShow()
          }
        }
      })
    },
    siteSelectList(id) {

      siteSelectList({}).then(res => {
        if (res.data.length > 0) {
          this.queryAnonymousJS(id)
        } else {
          this.$refs.anonymous.dialogVisible = true
        }
      })
    },
    // 涮新 公司站点
    clickFlash(id) {
      // this.$refs.SearchheadCheckbox.siteSelectList()
      this.siteSelectList(id)
    },
    clickTab(item, index) {
      this.activeShow = index
      this.Data = ''
      this.DataParams.date = getDay(item.date) + ',' + getDay(0)
      this.newCompany({ ...this.DataParams, ...this.lastParams })
    },
    changeData() {
      this.activeShow = -1
      this.DataParams.date = this.Data.join(',')
      this.newCompany({ ...this.DataParams, ...this.lastParams })
    },
    setCondition(val) {
      this.lastParams = val
      // if(this.lastParams.areaCode) this.lastParams.areaCode = this.lastParams.areaCode.map(e=>this.selectAreaFlattenMap[e].label)
      this.list.pageNum = 1
      this.newCompany({ ...this.DataParams, ...this.lastParams })
    },
    removeHtml(str) {
      const reTag = /<(?:.|\s)*?>/g
      return str.replace(reTag, '').replace(/&nbsp;/ig, '')
    },
    async newCompany(val) {
      this.waiting = true
      const params = {
        date: getDay(-7) + ',' + getDay(0),
        pageNum: this.list.pageNum,
        pageSize: this.list.pageSize,
        query: this.$route.query.word,
        ...val,
        ...this.DataParams
      }
      try {
        const { data } = await queryAnonymousCompany(params)
        console.log(data)
        this.list.total = data.total > 15000 ? 15000 : data.total

        // 新企业数据没有 alias 字段 目前产品说取前四个字
        const zz = /[\u4e00-\u9fa5]/g
        this.list.tableData = data.items.map(e => {
          if (this.removeHtml(e.companyName).match(zz)) {
            return { ...e, alias: e.alias || this.removeHtml(e.companyName).match(zz).join('').substr(0, 4) }
          } else {
            return { ...e, alias: e.alias || this.removeHtml(e.companyName).substr(0, 4) }
          }
        })
        this.waiting = false
      } catch (err) {
        this.waiting = false
      }
    },
    handlePage(val) {
      if (this.list.pageNum !== val) {
        this.list.pageNum = val
        this.newCompany(this.lastParams)
      }
    },
    handlePageNum(val) {
      this.list.pageNum = 1
      this.list.pageSize = val
      this.newCompany(this.lastParams)
    }
  }
}
</script>

<style lang="scss" scoped>
.font-15-md {
  font-size: 15px;
  font-weight: 600;
  color: rgba(52, 57, 81, 0.7);
}
/deep/.checkBox_head {
  .checkBoxes {
    padding-top: 72px;
    padding-bottom: 15px;
  }
}
.main {
  position: relative;
  padding-bottom: 24px;
  .max-title {
    font-size: 16px;
    font-weight: 600;
    color: #343951;
    line-height: 22px;
    padding-bottom: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .a1 {
      font-size: 13px;
      font-weight: 400;
      color: #999999;
      line-height: 18px;
    }
  }
}
/deep/ .item-list {
  b {
    font-size: 20px;
  }
  // width: calc(100% - 30px);
  background: #ffffff;
  // height: 72px;
  // line-height: 50px;
  padding: 0 24px;
  padding-top: 26px;
  padding-bottom: 14px;
  position: absolute;
  top: 149px;
  left: 0px;
  right: 0px;
  margin: 0 auto;
  z-index: 1;
  // border-bottom: 1px solid #F2F2F2;
  .el-button {
    border: 1px solid #e8e8f0;
    span {
      color: #555555;
    }
  }
  .el-button--dialog-confirm {
    border: none;
    span {
      color: #ffffff;
    }
  }

  &::after {
    content: " ";
    display: block;
    position: absolute;
    bottom: 0;
    width: 100%;
    border-bottom: 1px solid rgba(187, 190, 202, 0.3);
  }
}
.ccl {
  // width: calc(100% - 30px);
  margin: 0 auto;
  margin-top: 33px;
}
.tabItem {
  display: inline-block;
  border: 1px solid #ddd;
  width: 60px;
  height: 32px;
  line-height: 31px;
  text-align: center;
  cursor: pointer;
}
.tabItem:nth-child(2) {
  border-radius: 4px 0px 0px 4px;
}
.tabItem:last-child {
  border-radius: 0px 4px 4px 0px;
}
.tabItem + .tabItem {
  border-left: none;
}
/deep/ .el-col-3 {
  width: 9.5%;
}
/deep/ .el-col-21 {
  width: 90.5%;
}
.activeClass {
  background: #409eff;
  color: #fff;
}
/deep/ .el-range-editor--small.el-input__inner {
  margin-right: 20px;
}
.tips {
  width: 460px;
  font-size: 12px;
  color: #999999;
  line-height: 17px;
  padding-left: 12px;
}
</style>
